// Time-bucketed run aggregates for the dedup-analytics page (DEV-16231).
// Projection over the Run table — no new persistence. Cross-package
// contract: schemas live here; types are inferred.
import { z } from 'zod';
export const RunTimeseriesBucketSchema = z.enum(['hour', 'day']);
/**
 * Query string for `GET /v1/run-timeseries`. All filters optional;
 * omitted fields are unconstrained. `windowHours` is clamped server-side
 * to [1, 720] (max 30 days) — keeps the bucket count bounded. When `since`
 * is provided it overrides the rolling-window math; `until` defaults to
 * "now" so a since-only request is "from X up to right now".
 */
export const RunTimeseriesQuerySchema = z
    .object({
    bucket: RunTimeseriesBucketSchema.optional(),
    windowHours: z.number().int().positive().max(720).optional(),
    since: z.string().datetime().optional(),
    until: z.string().datetime().optional(),
    workflowId: z.string().min(1).optional(),
    signalKey: z.string().min(1).optional(),
})
    .strict();
/**
 * One time bucket — total runs created in the window plus the dedup
 * breakdown the orchestrator stamped on cancelled rows. `dupOfSignal`
 * = Mode A (matched an open signal); `dupOfInFlight` = Mode B (matched
 * an in-flight run sharing the key).
 */
export const RunTimeseriesBucketRowSchema = z.object({
    at: z.string().datetime(),
    totalRuns: z.number().int().nonnegative(),
    dupOfSignal: z.number().int().nonnegative(),
    dupOfInFlight: z.number().int().nonnegative(),
});
export const RunTimeseriesWorkflowRowSchema = z.object({
    workflowId: z.string(),
    workflowName: z.string(),
    runs: z.number().int().nonnegative(),
    deduped: z.number().int().nonnegative(),
    /** deduped / runs, 0 when runs == 0. */
    dedupRate: z.number(),
});
export const RunTimeseriesKeyRowSchema = z.object({
    signalKey: z.string(),
    runs: z.number().int().nonnegative(),
    deduped: z.number().int().nonnegative(),
});
export const RunTimeseriesResponseSchema = z.object({
    bucket: RunTimeseriesBucketSchema,
    windowHours: z.number().int().positive(),
    buckets: z.array(RunTimeseriesBucketRowSchema),
    /** Top 10 workflows by dedup rate over the window. */
    topWorkflows: z.array(RunTimeseriesWorkflowRowSchema),
    /** Top 10 signal keys by trigger count over the window. */
    topKeys: z.array(RunTimeseriesKeyRowSchema),
});
//# sourceMappingURL=run-timeseries.js.map